module.exports = __webpack_public_path__ + "static/media/unsaveBookmark.7dcbead9.png";